import { render, staticRenderFns } from "./ChooseTeam.vue?vue&type=template&id=6dd567be&"
import script from "./ChooseTeam.vue?vue&type=script&lang=js&"
export * from "./ChooseTeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports